import { createSelector } from 'reselect';
import { coalesce } from 'src/utils/utils';
import { AgreementMapEx } from '../funds/UserFunds';
import { getAgreementMap } from '../funds/UserFunds/userFunds.selectors';
import { ApplicationState } from '../types';

export const EMPTY_AGREEMENT_MAP: Partial<AgreementMapEx> = {
  associableLookup: {},
  associatedLookup: {},
  associatedPurchaseRestrictedLookup: {},
  restrictedLookup: {},
};

export const getBankSelection = ({ bankSelection }: ApplicationState) =>
  bankSelection;
/**
 * Simple selector to extract cartLookup selected bank object from the shopping cart.
 * @param state
 * @returns {Bank|null} Currently selected bank
 */
export const getSelectedBank = createSelector(
  [getBankSelection],
  (bankSelection) => bankSelection?.selectedBank
);

export const getSelectedBankServiceFeatures = createSelector(
  [getSelectedBank],
  (bank) => bank && bank?.bankAgreementSerivceFeatures
);
/**
 * Complex selector to extract the agreement map corresponding to the selected bank. or a 'default' agreement map
 * with empty lookups if no bank is selected.
 * @param state
 * @returns {AgreementMapEx}
 */
export const getSelectedBankAgreementMap = createSelector(
  [getAgreementMap, getSelectedBank],
  (agreementMap, selectedBank) =>
    coalesce(
      agreementMap &&
        selectedBank &&
        agreementMap[selectedBank.bankAgreementID],
      EMPTY_AGREEMENT_MAP
    )
);

/**
 * Complex selector to extract to combine the associable and associated lookups for the selected bank into a
 * single lookup object.
 * @param state
 * @returns {Object.<string, boolean>} key = fund.uniqueKey, value = true
 */
export const getSelectedBankAssociableOrAssociatedLookup = createSelector(
  getSelectedBankAgreementMap,
  ({ associableLookup, associatedLookup }) =>
    Object.assign({}, associableLookup, associatedLookup)
);

export const getSelectedBankAssociableLookup = createSelector(
  getSelectedBankAgreementMap,
  ({ associableLookup }) => associableLookup
);
